import {gettext} from 'topmeteo/utils/i18n';

const Message = gettext('You are currently not logged in and therefore are seeing some airports we selected for you. Please log in to choose your own start and destination.');

const Anonymous = () => (
    <div className="notification anonymous-notice">
        <div className="notifications-inner alert" role="alert">
            <p>{Message}</p>
        </div>
    </div>
);

export default Anonymous;
